<div class="bk-dialog">
	
	<h4 mat-dialog-title>
		{{ 'Technical Support' | translate }}
	</h4>

	<div mat-dialog-content>
		<p>
			{{ 'technical support explanation text' | translate }}
		</p>
		<textarea
			class='bk-feedback__textarea'
			[(ngModel)]='description'
			placeholder="{{ 'Please describe your issue' | translate }}.">
		</textarea>
	</div>

	<div mat-dialog-actions align="end">

		<button (click)="cancel()" mat-button
			class="bk-button--medium bk-dialog__button--secondary bk-button--text-only">
			{{ 'Cancel' | translate }}
		</button>

		<button
			[disabled]="!description"
			(click)="send()"
			mat-button
			class="bk-button bk-button--medium">
			{{ 'Send' | translate }}
		</button>
	</div>
</div>